import SEO from '../components/SEO.jsx';

const SECTIONS = [
  {
    title: 'מי אחראי על המידע',
    body: `FocusMode הוא שמו המסחרי של יואב רון, מספר ח.פ. / עוסק מורשה, גבעת השלושה, ישראל. לפניות בנושא פרטיות: yoav@focusmode.info`
  },
  {
    title: 'איזה מידע אנחנו אוספים',
    body: `• מידע שאתה מוסר: שם, מספר טלפון, כתובת מייל — כשפונה אלינו דרך טופס יצירת קשר או WhatsApp.\n• מידע טכני: כתובת IP, סוג דפדפן, עמודים שנצפו, זמן שהייה — נאסף אוטומטית דרך כלי ניתוח (ראה סעיף עוגיות).\n• מידע שאינו נאסף: אנחנו לא אוספים נתוני כרטיס אשראי, מספרי זהות, או מידע רגיש אחר.`
  },
  {
    title: 'למה אנחנו משתמשים במידע',
    body: `• מענה לפניות ויצירת קשר עסקי.\n• שיפור האתר וחוויית המשתמש.\n• שליחת עדכונים שביקשת (ניוזלטר) — בהסכמה מפורשת בלבד.\n• עמידה בדרישות חוקיות.`
  },
  {
    title: 'עוגיות (Cookies) וכלי ניתוח',
    body: `האתר משתמש בכלים הבאים:\n\n• Google Analytics 4 — ניתוח תנועה אנונימי. נתוני IP מאוחסנים בצורה מקוצרת. מדיניות פרטיות Google: policies.google.com/privacy\n• Meta Pixel (Facebook/Instagram) — למדידת אפקטיביות פרסום ממומן. מדיניות: facebook.com/policy\n• TikTok Pixel — למדידת אפקטיביות פרסום ב-TikTok. מדיניות: tiktok.com/legal/privacy-policy\n\nניתן לסרב לעוגיות אנליטיות דרך באנר ההסכמה בתחתית האתר, או להגדיר זאת בדפדפן.`
  },
  {
    title: 'שיתוף מידע עם צדדים שלישיים',
    body: `אנחנו לא מוכרים, משכירים, או סוחרים במידע שלך. מידע עשוי לעבור לצדדים שלישיים רק:\n• לספקי שירות שמסייעים בהפעלת האתר: Vercel (אחסון האתר), Supabase (אחסון פניות), Resend (שליחת מיילים), Notion (מעקב פניות), Google (אנליטיקס).\n• כשמחויבים על-פי חוק.\n\nכל הספקים עובדים תחת הסכמי עיבוד נתונים תקניים (DPA).`
  },
  {
    title: 'אחסון ואבטחת מידע',
    body: `האתר פועל עם HTTPS מלא (TLS 1.2+) ועובד בהתאם ל-GDPR. פרטים שנשלחים דרך טופס יצירת הקשר נשמרים במערכות שלנו לצורך מענה ומעקב, ומועברים לספקי השירות שמפעילים אותן. פניות בוואטסאפ ובמייל מגיעות ישירות אלינו ולא נשמרות במערכת נפרדת.`
  },
  {
    title: 'הזכויות שלך',
    body: `בהתאם לחוק הגנת הפרטיות (ישראל) ו-GDPR (לתושבי האיחוד האירופי) יש לך זכות:\n• לעיין במידע שנאסף עליך.\n• לתקן מידע שגוי.\n• למחוק את המידע ("הזכות להישכח").\n• להתנגד לעיבוד לצרכי שיווק.\n• לקבל עותק של המידע (ניידות נתונים).\n\nלמימוש הזכויות: yoav@focusmode.info — מענה תוך 30 יום.`
  },
  {
    title: 'קישורים לאתרים חיצוניים',
    body: `האתר עשוי לכלול קישורים לאתרים חיצוניים. איננו אחראים למדיניות הפרטיות של אתרים אלה.`
  },
  {
    title: 'שינויים במדיניות',
    body: `שינויים מהותיים יפורסמו בדף זה עם תאריך עדכון. שימוש מתמשך באתר לאחר שינוי מהווה הסכמה למדיניות המעודכנת.`
  },
  {
    title: 'יצירת קשר',
    body: `לשאלות בנושא פרטיות:\nEmail: yoav@focusmode.info\nWhatsApp: 052-410-6717\nגבעת השלושה, ישראל`
  },
];

export default function Privacy() {
  return (
    <main style={{ direction: 'rtl', fontFamily: 'Heebo, sans-serif' }}>
      <SEO
        title="מדיניות פרטיות · FocusMode"
        description="מדיניות הפרטיות של FocusMode — כיצד אנחנו אוספים, משתמשים ומגנים על המידע שלך."
        path="/privacy"
      />
      <section className="sec wrap" style={{ maxWidth: 760 }}>
        <div className="sec-eyebrow">מסמך משפטי · Privacy Policy</div>
        <h1 className="h2">מדיניות פרטיות</h1>
        <p className="lede" style={{ marginBottom: 8 }}>
          עודכן לאחרונה: 12 במאי 2026
        </p>
        <p style={{ fontSize: 16, lineHeight: 1.7, color: 'var(--ink-2)', marginBottom: 40 }}>
          FocusMode מכבדת את פרטיותך ומחויבת להגנה על המידע האישי שאתה משתף איתנו.
          מדיניות זו מסבירה אילו נתונים נאספים, כיצד הם משמשים, ומהן זכויותיך.
        </p>

        {SECTIONS.map((s, i) => (
          <div key={i} style={{ marginBottom: 36, paddingBottom: 36, borderBottom: '1px solid var(--paper-2)' }}>
            <h2 style={{ fontFamily: 'Heebo, sans-serif', fontWeight: 900, fontSize: 'clamp(18px,2vw,22px)', marginBottom: 12 }}>
              {i + 1}. {s.title}
            </h2>
            <p style={{ fontSize: 16, lineHeight: 1.8, color: 'var(--ink-2)', whiteSpace: 'pre-line', margin: 0 }}>
              {s.body}
            </p>
          </div>
        ))}
      </section>
    </main>
  );
}
